import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navItems = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/projects', label: 'Projects' },
        { path: '/experience', label: 'Experience' },
        { path: '/education', label: 'Education' },
        { path: '/contact', label: 'Contact' }
    ];

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <motion.nav
            className={`navbar ${scrolled ? 'scrolled' : ''}`}
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="container">
                <Link to="/" className="navbar-brand" onClick={closeMenu}>
                    <motion.span
                        whileHover={{ scale: 1.05 }}
                        className="brand-text"
                    >
                        Portfolio
                    </motion.span>
                </Link>

                <div className="navbar-menu">
                    <ul className="nav-links">
                        {navItems.map((item) => (
                            <motion.li key={item.path} whileHover={{ scale: 1.1 }}>
                                <Link
                                    to={item.path}
                                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                                    onClick={closeMenu}
                                >
                                    {item.label}
                                </Link>
                            </motion.li>
                        ))}
                    </ul>
                </div>

                <div className="navbar-toggle" onClick={toggleMenu}>
                    <motion.div
                        whileTap={{ scale: 0.9 }}
                        className="hamburger"
                    >
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </motion.div>
                </div>
            </div>

            {/* Mobile Menu */}
            <motion.div
                className={`mobile-menu ${isOpen ? 'open' : ''}`}
                initial={{ opacity: 0, x: '100%' }}
                animate={{
                    opacity: isOpen ? 1 : 0,
                    x: isOpen ? '0%' : '100%'
                }}
                transition={{ duration: 0.3 }}
            >
                <ul className="mobile-nav-links">
                    {navItems.map((item) => (
                        <motion.li
                            key={item.path}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Link
                                to={item.path}
                                className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                {item.label}
                            </Link>
                        </motion.li>
                    ))}
                </ul>
            </motion.div>
        </motion.nav>
    );
};

export default Navbar; 